var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPolyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1920 1080",
    width: 1920,
    height: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#001D4A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1068 67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -117.5L101.7 -58.7L101.7 58.7L0 117.5L-101.7 58.7L-101.7 -58.7Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1373 363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -73L63.2 -36.5L63.2 36.5L0 73L-63.2 36.5L-63.2 -36.5Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(839 585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -94L81.4 -47L81.4 47L0 94L-81.4 47L-81.4 -47Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(394 1078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -111L96.1 -55.5L96.1 55.5L0 111L-96.1 55.5L-96.1 -55.5Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -115L99.6 -57.5L99.6 57.5L0 115L-99.6 57.5L-99.6 -57.5Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1251 863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -107L92.7 -53.5L92.7 53.5L0 107L-92.7 53.5L-92.7 -53.5Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(813 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -21L18.2 -10.5L18.2 10.5L0 21L-18.2 10.5L-18.2 -10.5Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(481 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -107L92.7 -53.5L92.7 53.5L0 107L-92.7 53.5L-92.7 -53.5Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336 773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -114L98.7 -57L98.7 57L0 114L-98.7 57L-98.7 -57Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -87L75.3 -43.5L75.3 43.5L0 87L-75.3 43.5L-75.3 -43.5Z",
    fill: "#0651c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -116L100.5 -58L100.5 58L0 116L-100.5 58L-100.5 -58Z",
    fill: "#0651c3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPolyDark);
export default __webpack_public_path__ + "static/media/heroPolyDark.e6c93a8eb5a26c440c8974a4ee2cc360.svg";
export { ForwardRef as ReactComponent };